import React, {useState} from "react";
import  './TextForm.css'
import './Preview.css'

export default function TextForm(props) {
    const [text, setText] = useState('Your text goes here');
    const [Preview, setPreview] = useState('Your text goes here');
    const [Emails, setEmails] = useState('');
    const [SortInput, setSortInput] = useState('');
    const [SortTitle, setSortTitle] = useState('');

    // const [mystyle, setMystyle] = useState({
    //   color : 'black',
    //   backgroundColor : 'white'
    // })

    // if (props.mode === 'light') {
    //   setMystyle({
    //     color : 'black',
    //     backgroundColor : 'white'
    //   })
    // }else{
    //   setMystyle({
    //     color : 'white',
    //     backgroundColor : 'black'
    //   })
    // }

    // {color : 'black';backgroundColor : 'white'}

    const handleonChange = (event)=>{
        console.log("handleonChange");
        setText(event.target.value);
    }
    const handleupClick = ()=>{
        // console.log("Clicked");
        let newText = text.trim().toUpperCase();
        // setText(newText);
        
        if (newText) {
          setPreview(newText);
          setEmails('');
          setSortInput('');
          props.showAlert(
            "success",
            "Your Text Has Been Converted To The Uppercase Format Successfully!"
          );
        }else{
          props.showAlert(
            "warning",
            "No Data Found!"
          );
        }
    }

    const handledownClick = ()=>{
        // console.log("Clicked");
        let newText = text.trim().toLowerCase();
        // setText(newText);
        if (newText){
          setPreview(newText);
          setEmails('');
          setSortInput('');
          props.showAlert('success','Your Text Has Been Converted To The Lowercase Format Successfully!');
        }else{
          props.showAlert(
            "warning",
            "No Data Found!"
          );
        }
    }

    const handleCopyClick = ()=>{
      navigator.clipboard.writeText(text);
      // console.log("Text copied");
      if (text)
      props.showAlert('success','Your Text Has Been Copied Successfully!');
    }

    const handleCopyPreviewClick = ()=>{
      navigator.clipboard.writeText(Preview);
      console.log("Preview Copied: "+Preview);
      if (Preview)
      props.showAlert('success','Your Text Has Been Copied Successfully!');
    }

    const handleClearClick = ()=>{
        // console.log("Clear")
        let newText = '';
        setText(newText);
        setPreview(newText);
        setEmails(newText);
        setSortInput(newText);
        if (newText)
        props.showAlert('success','The Text Has Been Cleared Successfully!');
    }

    const handleExtraSpacesClick = ()=>{
      // console.log("extra spaces removed");
      let newText = text.split(/[ ]+/);
      // setText(newText.join(' '));
      if (newText){
        setPreview(newText.join(' '));
        setEmails('');
        setSortInput('');
        props.showAlert('success','Extra Spaces Have Been Removed Successfully!');
      }
    }

    const handleExtractEmails = () => {
      const emails = text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g);
      console.log("E-mails: "+( emails instanceof Array));
      console.log("Emails: "+Emails);
      if(emails instanceof Array){
        setEmails(emails);
        setPreview(emails);
        setSortInput('');
        props.showAlert('success','E-mails Have Been Extracted Successfully!');
      }else{
        props.showAlert('warning','No E-Mail Found!');
      }
    }

    const handleAscendingOrder = () => {
      const temp = text.trim();
      const arr = temp.split(" ");

      if (arr instanceof Array && arr.length > 1) {
        arr.sort();
        setSortTitle("Ascending");
        setSortInput(arr);
        console.log("arr:" + arr.toString() + " : " + (arr instanceof Array));
        let tempText = "";
        for (let i = 0; i < arr.length; i++) {
          tempText += arr[i].toString() + ",";
          if (i === arr.length - 1) tempText += arr[i].toString();
        }
        setPreview(tempText);
        setEmails("");
        props.showAlert("success", "Your Text Has Been Sorted Successfully!");
      }else{
        props.showAlert(
          "warning",
          "No Data Found!"
        );
      }
    };

    const handleDescendingOrder = () => {
      const temp = text.trim();
      const arr = temp.split(" ");

      if (arr instanceof Array && arr.length > 1) {
        arr.sort();
        arr.reverse();
        setSortTitle("Descending");
        setSortInput(arr);

        console.log("arr:" + arr.toString() + " : " + (arr instanceof Array));
        let tempText = "";
        for (let i = 0; i < arr.length; i++) {
          tempText += arr[i].toString() + ",";
          if (i === arr.length - 1) tempText += arr[i].toString();
        }
        setPreview(tempText);
        setEmails("");
        props.showAlert("success", "Your Text Has Been Sorted Successfully!");
      }else{
        props.showAlert(
          "warning",
          "No Data Found!"
        );
      }
    };
    
    const handleGenerateText = () => {
        setText(
          `TextTidy is a powerful web application that simplifies text processing tasks. With features like case conversion, word and character counting, text trimming, and more, it helps you quickly format and analyze your content. Whether you're writing, editing, or just organizing text, TextTidy saves you time and effort!`
        );
    }

  return (
    <>
    <div className={` my-5 p-3 text-${props.mode==='light'?'dark':'light'}`} style={{backgroundColor: props.mode==='light'?'white':'#e2dcdc'}}>
        <h6>{props.heading}</h6>
      <div className="mb-3">
        <textarea
          className="form-control custom-textarea"
          id="myBox"
          rows="8"
          value={text}
          onChange={handleonChange}
          style={{backgroundColor: props.mode==='light'?'white':'#e2dcdc', color: props.mode==='light'?'black':'black'}}
        ></textarea>
      </div>
      <div className="">
          <div className="row g-3" >
            {/* <div className="col-6 col-md-4 col-lg-2"> */}
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" onClick={handleExtractEmails}>Extract E-Mails</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" title="Use Whitespace as Delimiter" onClick={handleDescendingOrder}>Sort In Descending Order</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" title="Use Whitespace as Delimiter" onClick={handleAscendingOrder}>Sort In Ascending Order</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" onClick={handleupClick}>Convert to Uppercase</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" onClick={handledownClick}>Convert to Lowercase</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" onClick={handleCopyClick}>Copy Text</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" onClick={handleCopyPreviewClick}>Copy Preview</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" onClick={handleClearClick}>Clear Text</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" onClick={handleExtraSpacesClick}>Remove Extra Spaces</button>
            <button className="button col-6 col-md-4 col-lg-2 btn btn-sm btn-primary mx-2" onClick={handleGenerateText}>Use Sample Text</button>
            {/* </div> */}
          </div>
      </div>
    </div>
  <div className={`  my-3 text-${props.mode==='light'?'dark':'light'}`}>
      <h2 className="summary">Your Text Summary</h2>
      <p className="engraved"> {!text | text.trim()===''? 0:text.trim().split(/[ ]+/).length} words and {text.trim().length} characters</p>
      <p className="engraved"> It takes an average time of {0.008 * text.split(" ").length} minutes to read</p>
      <h2 className="engraved" style={{color: '#4ecca3', backgroundColor:'whitesmoke'}}>Preview</h2>
      <p style={{wordWrap: 'break-word', overflow : 'break-word', whiteSpace: 'normal'}}>{Preview}</p>

      {(Emails !== '' && Emails !== null) &&
        <div className="overflow-auto" style={{height:'500px'}}>
        <h5 style={{color: '#4ecca3'}}>E-mails:</h5>
        <ol>{Emails.map((email,index)=>{
          return (
            <li key={index}>{email}</li>
          )
        })}</ol>
      </div>
      }

      {(SortInput !== '' && SortInput !== null) &&
        <div className="container">
        <h5>Sorted (Left to Right) In {SortTitle} Order:</h5>
          <div className="row">
        {SortInput.map((word,index)=>{
          return (
            <div className="col-6 col-md-4 col-lg-2" key={index}>
              {word}
            </div>
          )
        })}
         </div>
      </div>
      } 
      
    </div>
    </>
  );
}
